import type { ConnectHandoffCompletionCode } from '@/lib/play/connectHandoffTypes'

export const CONNECT_HANDOFF_COMPLETION_COPY: Record<
  ConnectHandoffCompletionCode,
  { title: string; message: string }
> = {
  CONNECTED: {
    title: 'You are connected',
    message: 'You and your dog are now in each other’s Play Circle.',
  },
  ALREADY_CONNECTED: {
    title: 'Already connected',
    message: 'These dogs are already connected in Wagamour.',
  },
  DECLINED: {
    title: 'Connection declined',
    message: 'You chose not to connect. You can always meet again at the park.',
  },
  CONNECTION_NO_LONGER_AVAILABLE: {
    title: 'Connection unavailable',
    message: 'This connection is no longer available.',
  },
  EXPIRED_CONNECTION_LINK: {
    title: 'Link expired',
    message: 'This connection link has expired. Ask your friend to share a new one.',
  },
  INVALID_CONNECTION_LINK: {
    title: 'Invalid link',
    message: 'This connection link is not valid.',
  },
  NOT_PLAY_READY: {
    title: 'Complete your Play profile',
    message: 'Finish your dog’s Play profile to connect with other dogs.',
  },
  REQUIRES_DOG: {
    title: 'Add your dog',
    message: 'Add a dog to your profile to continue this connection.',
  },
  REQUIRES_SIGN_IN: {
    title: 'Sign in to continue',
    message: 'Sign in or create an account to connect your dogs.',
  },
  RESUME_ATTACH_FAILED: {
    title: 'Could not resume',
    message: 'We could not restore this connection. Try opening the link again.',
  },
  ACCOUNT_MISMATCH: {
    title: 'Sign in to continue',
    message: 'Sign in with the account you want to use for this connection.',
  },
  SELF_CONNECTION: {
    title: 'Use another account',
    message:
      'You can’t accept your own Connect invitation. Open this link while signed in as a different dog parent.',
  },
}
